import { useEffect, useState } from 'react';
import AuftragDetailComponent from '../../component/AuftragDetailComponent/AuftragDetailComponent';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';

/**
 * @author noone
 */
export default function AuftragDetails() {
  var url = window.location;
  let params = new URLSearchParams(url.search);

  const [uid, setUid] = useState<string | null>();
  const [backbuttonClose, setBackButtonClose] = useState<boolean>(false);

  useEffect(() => {

    var strUid = params.get('uid');
    if (strUid !== null && strUid !== undefined)
      setUid(strUid);

    var strBackButtonClose = params.get('backbuttonClose');
    if (strBackButtonClose !== null) {
      const backButtonClose = strBackButtonClose === 'true';
      setBackButtonClose(backButtonClose);
    }
  }, []);

  return (
    <>

      <LandingpageHeader />

      {uid !== null && uid !== undefined &&
        <AuftragDetailComponent uid={uid!!} backbuttonClose={backbuttonClose} backbuttonVisible={true} />
      }

      <Footer />
    </>
  );

}
